import { Product, ProductKey } from "app/shared/model/ProductBase";
import DateHelper from "./dateHelper";
import stringHelper from "./stringHelper";

const generateCSV = <T extends Product>(dataList:T[], fileName: string) => {

    let csvContent:string = '';
    let cvsHeaders:string = '';

    if(dataList)
    {
        dataList.forEach((data, index) => {
            let rowContent:string = '';

            for(const [key, value] of Object.entries(data as ProductKey)) {

                if(index === 0) {
                    cvsHeaders += `${stringHelper.toTitleCase(key)},`;
                }
                
                //formatValue
                let formattedValue:any = value;
                if(formattedValue instanceof Date) {
                    formattedValue = DateHelper.ToDateString(formattedValue);
                }
                
                rowContent += (String(formattedValue).includes(' ')) ? `"${formattedValue}",` : `${formattedValue},`;
            }
            
            csvContent += (index === 0) ? `${cvsHeaders} \n ${rowContent} \n` : `${rowContent} \n`;
        });

        //Creating CSV file
        downloadCSV(csvContent, fileName);        
    }
}

const downloadCSV = (csvContent: string, fileName: string) => {
    let BOM = "\uFEFF";
    const blob = new Blob([`${BOM}${csvContent}`], {type: 'text/csv;charset=utf-8,' });

    var link = document.createElement('a');
        if(link.download !== undefined)
        {
            var url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `${fileName}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
}

const fileHelper = {generateCSV, downloadCSV};

export default fileHelper;